/*
    UBT数据头定义为app.project[.scene.ab.theme]-page[.element]。
    中括号中的字段可选，但是要注意，如果需要设置后面的字段，前面的字段也必须保留，统一使用默认值0。例如wk.opu2.0.a，scene是不需要，但是因为ab存在，所以要设置为默认值0。
    各个字段说明如下：
    "wk.opu02.a.a-home.rec_list_x"
    app：站点标识，为了和玄武的保持一致，内置微课H5为wk，蒲公英位pgy，微课APP为wka。
    project：项目名，运营活动统一以opu开头，例如opu2。
    scene：入口场景值，用来标识用户从哪里进来。
    ab：A/B测试标识，统一使用字母表示。
    theme：皮肤主题标识。
    page：页面标识，最好有明确语义
    element：控件标识，最好有明确语义

    运营打点文档记录
    https://gitlab.weike.fm/oc/oc-docs/blob/master/records/%E8%BF%90%E8%90%A5%E6%B4%BB%E5%8A%A8%E5%9F%8B%E7%82%B9%E5%8D%8F%E8%AE%AE.md
*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import request from './axios.config';
import { isTest, getLocationParamValue } from '@/utils/util';
var scene = getLocationParamValue('scene') ? "." + getLocationParamValue('scene') : '';
export var RegisterPage = {
    opu5_home: "opu5" + scene + "-opu5_home",
    opu5_coupon: "opu5" + scene + "-opu5_coupon",
    opu11_coupon: "opu11" + scene + "-opu11_coupon",
    opu5_simple_channel: "opu11" + scene + "-opu11_simple_channel",
    opu1_membercard: 'opu1-membercard',
    opu1_paid: "opu1" + scene + "-paid",
    opu1_unpaid: "opu1" + scene + "-unpaid" // 学习卡未付费用户埋点
};
export var RegisterElement;
(function (RegisterElement) {
    /** 解锁模块 */ RegisterElement["unlock_module"] = "unlock_module";
    /** 0元解锁按钮模块 */ RegisterElement["unlock_btn_click"] = "unlock_btn_click";
    /** 邀请按钮点击 */ RegisterElement["unlock_inviter"] = "unlock_inviter";
    /** 主会场访问 */ RegisterElement["page"] = "page";
    /** 预约邀请卡 */ RegisterElement["unlock_subscribe"] = "unlock_subscribe";
    RegisterElement["coupon_channel_inview"] = "coupon_channel_inview";
    RegisterElement["coupon_channel_click"] = "coupon_channel_click";
    RegisterElement["coupon_floatIcon_click"] = "coupon_floatIcon_click";
    RegisterElement["coupon_invited_card_popup"] = "coupon_invited_card_popup";
    RegisterElement["coupon_open_lucky_pocker"] = "coupon_open_lucky_pocker";
    RegisterElement["coupon_lucky_pocker_useCoupon"] = "coupon_lucky_pocker_useCoupon";
    RegisterElement["coupon_share_pocker_popup"] = "coupon_share_pocker_popup";
    RegisterElement["coupon_share_pocker_useCoupon"] = "coupon_share_pocker_useCoupon";
    RegisterElement["coupon_book_seckill"] = "coupon_book_seckill";
    RegisterElement["coupon_switchtab_seckill"] = "coupon_switchtab_seckill";
    RegisterElement["coupon_robcoupon_seckill"] = "coupon_robcoupon_seckill";
    RegisterElement["coupon_sharebtn_seckill"] = "coupon_sharebtn_seckill";
    RegisterElement["coupon_usecouponclick_seckill"] = "coupon_usecouponclick_seckill";
    RegisterElement["coupon_sharecard_seckill"] = "coupon_sharecard_seckill";
    RegisterElement["coupon_sharecard_luckybag"] = "coupon_sharecard_luckybag";
    RegisterElement["luckybox_clsoe"] = "luckybox_clsoe";
    RegisterElement["tab_canuse_coupon"] = "tab_canuse_coupon";
    RegisterElement["coupon_lucky_pocker_useCoupon_Btn"] = "coupon_lucky_pocker_useCoupon_Btn";
    // 主会场
    RegisterElement["unsign_studycard_click"] = "unsign_studycard_click";
    RegisterElement["sign_studycard_click"] = "sign_studycard_click";
    RegisterElement["suprise_box_popup"] = "suprise_box_popup";
    RegisterElement["suprise_box_usecoupon"] = "suprise_box_usecoupon";
    RegisterElement["main_box_click"] = "main_box_click";
    RegisterElement["main_couponarea_click"] = "main_couponarea_click";
    RegisterElement["main_channel_click"] = "main_channel_click";
    RegisterElement["main_floatIcon_click"] = "main_floatIcon_click";
    // 简版详情页
    // simple_channel_payclick = 'simple_channel_payclick', // 支付按钮点击量
    RegisterElement["simple_channel_unsign_cancelpay_popup"] = "simple_channel_unsign_cancelpay_popup";
    RegisterElement["simple_channel_sign_cancelpay_popupclick"] = "simple_channel_sign_cancelpay_popupclick";
    RegisterElement["simple_channel_sign_cancelpay_rebuy"] = "simple_channel_sign_cancelpay_rebuy";
    RegisterElement["simple_channel_unsign_cancelpay_tostudycard"] = "simple_channel_unsign_cancelpay_tostudycard";
    // 学习卡
    RegisterElement["empty"] = "";
    RegisterElement["pay_btn_member"] = "pay_btn_member";
    RegisterElement["renew_btn_member"] = "renew_btn_member";
    RegisterElement["ch_list__free"] = "ch_list__free";
    RegisterElement["ch_list__coupon"] = "ch_list__coupon";
    RegisterElement["ch_list__fifty_p"] = "ch_list__fifty_p";
    RegisterElement["ch_list__top"] = "ch_list__top";
    RegisterElement["ch_list__low_off"] = "ch_list__low_off";
    RegisterElement["audition__item"] = "audition__item";
    RegisterElement["audition__video"] = "audition__video"; // 视频免费听 播放视频
})(RegisterElement || (RegisterElement = {}));
export var EventType;
(function (EventType) {
    EventType["impress"] = "impress";
    EventType["click"] = "click";
    EventType["view"] = "view";
    EventType["pay_channel_click"] = "pay_channel_click";
    EventType["pay_month_bag_click"] = "pay_month_bag_click"; // 点击购买月卡会员支付
})(EventType || (EventType = {}));
export var initSpm = '';
export function setSPM(page) {
    // init this function when page load init,exmaple useEffect or ComponentDidMount
    initSpm = "wk." + page;
    return "wk." + page;
}
export var reportServer = {
    reportServerAPI: function (param) {
        return request.post((isTest() ? 'https://collector.lizhiweike.com' : 'https://collector.lizhiweike.com') + "/api/data_collector/logs", { data: param }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },
};
/**
 * 合成ubt头
 * @param element  RegisterElement 上面注册的elment
 * @param evt_params  参数，可选
 */
export var combinationUbt = function (element) {
    try {
        return initSpm + "." + element;
    }
    catch (err) {
        console.log(err);
    }
};
/**
 * 页面访问
 * @param element  RegisterElement 上面注册的elment
 * @param evt_params  参数，可选
 */
export var reportViewEvent = function (element, evt_params) {
    if (evt_params === void 0) { evt_params = {}; }
    try {
        reportServer.reportServerAPI([
            {
                ubt: "" + element ? initSpm + "." + element : "" + initSpm,
                evt: EventType['view'],
                evt_params: evt_params,
            },
        ]);
    }
    catch (err) {
        console.log(err);
    }
};
/**
 * 点击埋点
 * @param element  RegisterElement 上面注册的elment
 * @param evt_params  参数，可选
 */
export var reportClickEvent = function (element, evt_params) {
    if (evt_params === void 0) { evt_params = {}; }
    try {
        reportServer.reportServerAPI([
            {
                ubt: initSpm + "." + element,
                evt: EventType['click'],
                evt_params: evt_params,
            },
        ]);
        return initSpm + "." + element;
    }
    catch (err) {
        console.log(err);
    }
};
/**
 * 学习卡支付埋点
 * @param element  RegisterElement 上面注册的elment
 * @param evt_params  参数，可选
 */
export var reportMonthBagClick = function (ubt, evt_params) {
    if (evt_params === void 0) { evt_params = {}; }
    try {
        reportServer.reportServerAPI([
            {
                ubt: ubt,
                evt: EventType['pay_month_bag_click'],
                evt_params: evt_params,
            },
        ]);
    }
    catch (err) {
        console.log(err);
    }
};
/**
 * pay_channel_click埋点
 * @param element  RegisterElement 上面注册的elment
 * @param evt_params  参数，可选
 */
export var reportLinkPayChannel = function (ubt, evt_params) {
    if (evt_params === void 0) { evt_params = {}; }
    try {
        reportServer.reportServerAPI([
            {
                ubt: ubt,
                evt: EventType['pay_channel_click'],
                evt_params: evt_params,
            },
        ]);
    }
    catch (err) {
        console.log(err);
    }
};
export var WrapChannelReport = function (eventSingle) {
    try {
        var len = eventSingle.length;
        var resultArray = [];
        var spm = eventSingle[0].spmElement;
        for (var i = 0; i < len; i++) {
            // @ts-ignore
            delete eventSingle[i].spmElement;
            resultArray.push({
                ubt: spm,
                evt: EventType.impress,
                evt_params: eventSingle[i],
            });
        }
        reportServer.reportServerAPI(resultArray);
    }
    catch (err) {
        console.log(err);
    }
};
export var hotSpotServer = {
    hotSpotLogs: function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    WrapChannelReport(data);
                }
                catch (error) {
                    console.log(error);
                }
                return [2 /*return*/];
            });
        });
    },
};



//////////////////
// WEBPACK FOOTER
// ./src/services/hotspotReport.ts
// module id = 195
// module chunks = 41